<template>
  <table class="m-table AgreementForm">
    <tbody>
      <tr>
        <th colspan="2">契約者名</th>
        <td colspan="2"><input type='text' v-model="agreement.f_name" placeholder="姓" @keypress.self.prevent.13></td>
        <td colspan="2"><input type='text' v-model="agreement.l_name" placeholder="名" @keypress.self.prevent.13></td>
        <th colspan="2">契約者名(かな)</th>
        <td colspan="2"><input type='text' v-model="agreement.f_name_kana" placeholder="せい" @keypress.self.prevent.13></td>
        <td colspan="2"><input type='text' v-model="agreement.l_name_kana" placeholder="めい" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">住所</th>
        <td colspan="4"><input type='text' v-model="agreement.address" placeholder="住所" @keypress.self.prevent.13></td>
        <th colspan="2">建物・部屋番号</th>
        <td colspan="4"><input type='text' v-model="agreement.address2" placeholder="建物・部屋番号" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">携帯TEL</th>
        <td colspan="4"><input type='text' required maxlength="11" minlength="10" v-model="agreement.tel" placeholder="携帯TEL" @keypress.self.prevent.13></td>
        <th colspan="2">固定TEL</th>
        <td colspan="4"><input type='text' maxlength="11" minlength="10" v-model="agreement.tel2" placeholder="固定TEL" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">契約種類</th>
        <td colspan="4"><multiselect @select="select" required v-model="watch.contract_type" :options="contract_type" label="name" :searchable="false" :show-labels="false" placeholder="契約種類"></multiselect></td>
        <th colspan="2" class="req">契約日付</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="agreement.contract_date" placeholder="契約日付" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">担当者</th>
        <td colspan="4"><input type='text' v-model="agreement.person" placeholder="担当者" @keypress.self.prevent.13></td>
        <th colspan="2">内容変更日付</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.change_date" placeholder="内容変更日付" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">解約種類</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.cancel_type" :options="cancel_type" label="name" :searchable="false" :show-labels="false" placeholder="解約種類"></multiselect></td>
        <th colspan="2">解約日付</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.cancel_date" placeholder="キャンセル日付" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">商品名</th>
        <td colspan="10"><input type='text' v-model="agreement.product_name" placeholder="商品名" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">合計ポイント</th>
        <td colspan="4"><input type='number' step='0.05' maxlength='5' v-model="agreement.point_total" placeholder="合計ポイント" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">支払方法種別</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.payment_type" :options="payment_type" label="name" :searchable="false" :show-labels="false" placeholder="支払方法種別"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2" class="req">テキスト種類</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.text_type" :options="text_type" label="name" :searchable="false" :show-labels="false" placeholder="テキスト種類"></multiselect></td>
        <th colspan="2">定価</th>
        <td colspan="4"><input type='text' v-model="agreement.amount" placeholder="定価" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">値引</th>
        <td colspan="4"><input type='text' v-model="agreement.discount" placeholder="値引" @keypress.self.prevent.13></td>
        <th colspan="2">販売価格</th>
        <td colspan="4"><input disabled type='text' :value="pure_amount" placeholder="販売価格" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">分割手数料</th>
        <td colspan="4"><input type='text' v-model="agreement.division_commission" placeholder="分割手数料" @keypress.self.prevent.13></td>
        <th colspan="2">お支払総額</th>
        <td colspan="4"><input disabled type='text' :value="total_amount" placeholder="お支払総額" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">支払回数</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.payments_number" :options="payments_number" label="name" :searchable="true" :show-labels="false" placeholder="支払回数"></multiselect></td>
        <th colspan="2">テキスト代入金日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.deposit_amount_date" placeholder="テキスト代入金日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">支払期間/開始(テキスト)</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.text_payment_period_start" placeholder="支払期間/開始(テキスト)" @keypress.self.prevent.13></td>
        <th colspan="2">支払期間/終了(テキスト)</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.text_payment_period_end" placeholder="支払期間/終了(テキスト)" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">役務期間/開始</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="agreement.service_period_start" placeholder="役務期間/開始" @keypress.self.prevent.13></td>
        <th colspan="2" class="req">役務期間/終了</th>
        <td colspan="4"><input type="text" required maxlength="10" minlength="10" v-model="agreement.service_period_end" placeholder="役務期間/終了" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">初月管理費支払方法</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.first_month_deposit_method" :options="method" label="name" :searchable="false" :show-labels="false" placeholder="初月管理費支払方法"></multiselect></td>
        <th colspan="2">初月管理費チェック</th>
        <td colspan="4"><input type='text' v-model="agreement.first_month_deposit_check" placeholder="初月管理費チェック" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2" class="req">入会金</th>
        <td colspan="4"><input type='text' required v-model="agreement.admission_fee" placeholder="入会金" @keypress.self.prevent.13></td>
        <th colspan="2">入会金支払方法</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.admission_fee_method" :options="method" label="name" :searchable="false" :show-labels="false" placeholder="入会金支払方法"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">入会金チェック</th>
        <td colspan="10"><input type='text' v-model="agreement.admission_fee_check" placeholder="入会金チェック" @keypress.self.prevent.13 @focus="focusAdmission_fee_check"></td>
      </tr>
      <tr>
        <th colspan="2" class="req">保証金</th>
        <td colspan="4"><input type='text' required v-model="agreement.deposit" placeholder="保証金" @keypress.self.prevent.13></td>
        <th colspan="2">保証金支払方法</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.deposit_method" :options="method" label="name" :searchable="false" :show-labels="false" placeholder="保証金支払方法"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">保証金チェック</th>
        <td colspan="4"><input type='text' v-model="agreement.deposit_check" placeholder="保証金チェック" @keypress.self.prevent.13 @focus="focusDeposit_check"></td>
        <th colspan="2" style="position: relative">銀行番号<agreements-bank :agreement="agreement" class="bank"></agreements-bank></th>
        <td colspan="4"><input type='text' v-model="agreement.bank_number" placeholder="銀行番号" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">支店番号</th>
        <td colspan="4"><input type='text' v-model="agreement.branch_number" placeholder="支店番号" @keypress.self.prevent.13></td>
        <th colspan="2">預金種目</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.deposit_item" :options="deposit_item" label="name" :searchable="false" :show-labels="false" placeholder="預金種目"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">口座番号</th>
        <td colspan="4"><input type='text' v-model="agreement.account_number" placeholder="口座番号" @keypress.self.prevent.13></td>
        <th colspan="2">口座名義</th>
        <td colspan="4"><input type='text' v-model="agreement.account_holder" placeholder="口座名義" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">保証金返金予定日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.expected_refund_date" placeholder="保証金返金予定日" @keypress.self.prevent.13></td>
        <th colspan="2">保証金返金日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.deposit_refund_date" placeholder="保証金返金日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">承認No.</th>
        <td colspan="4"><input type='text' maxlength='13' v-model="agreement.approval_number" placeholder="承認No." @keypress.self.prevent.13></td>
        <th colspan="2">承認日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.approval_date" placeholder="承認日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">学年</th>
        <td colspan="4"><input type='text' v-model="agreement.grade" placeholder="学年" @keypress.self.prevent.13></td>
        <th colspan="2">納品日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.delivery_date" placeholder="納品日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">契約書回収日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.contract_collection_date" placeholder="契約書回収日" @keypress.self.prevent.13></td>
        <th colspan="2">ファクター回収日</th>
        <td colspan="4"><input type="text" maxlength="10" minlength="10" v-model="agreement.factor_collection_date" placeholder="ファクター回収日" @keypress.self.prevent.13></td>
      </tr>
      <tr>
        <th colspan="2">ファクターチェック</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.factor_check" :options="factor_check" label="name" :searchable="false" :show-labels="false" placeholder="ファクターチェック"></multiselect></td>
        <th colspan="2">経理台帳入力</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.ledger_check" :options="ledger_check" label="name" :searchable="false" :show-labels="false" placeholder="経理台帳入力"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">CXLチェック</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.cancel_check" :options="cancel_check" label="name" :searchable="false" :show-labels="false" placeholder="CXLチェック"></multiselect></td>
        <th colspan="2">内容変更チェック</th>
        <td colspan="4"><multiselect @select="select" v-model="watch.change_check" :options="change_check" label="name" :searchable="false" :show-labels="false" placeholder="内容変更チェック"></multiselect></td>
      </tr>
      <tr>
        <th colspan="2">備考</th>
        <td colspan="10"><textarea v-model="agreement.note" placeholder="備考"></textarea></td>
      </tr>
    </tbody>
  </table>
</template>

<script>
export default {
  props: {
    agreement: Object,
    watch: Object
  },
  name: 'AgreementForm',
  data () {
    return {
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    },

    pure_amount () {
      const pure_amount = Number(this.agreement.amount) - Number(this.agreement.discount)
      this.agreement.pure_amount = pure_amount
      return pure_amount
    },

    total_amount () {
      const total_amount = this.pure_amount + Number(this.agreement.division_commission)
      this.agreement.total_amount = total_amount
      return total_amount
    },

    contract_type () {
      return this.$store.getters['agreements/contract_type']
    },

    cancel_type () {
      return this.$store.getters['agreements/cancel_type']
    },

    payment_type () {
      return this.$store.getters['agreements/payment_type']
    },

    text_type () {
      return this.$store.getters['agreements/text_type']
    },

    payments_number () {
      return this.$store.getters['agreements/payments_number']
    },

    method () {
      return this.$store.getters['agreements/method']
    },

    deposit_item () {
      return this.$store.getters['agreements/deposit_item']
    },

    factor_check () {
      return this.$store.getters['agreements/factor_check']
    },

    ledger_check () {
      return this.$store.getters['agreements/ledger_check']
    },

    cancel_check () {
      return this.$store.getters['agreements/cancel_check']
    },

    change_check () {
      return this.$store.getters['agreements/change_check']
    }
  },
  methods: {
    select (selectedOption, id) {
      // console.log(selectedOption)
    },

    focusAdmission_fee_check () {
      if (this.user.type === 'staff' && this.agreement.admission_fee_method === 2) {
        alert('支払方法が現金です、MGRに確認してください。')
        document.activeElement.blur()
      } else {
        return
      }
    },

    focusDeposit_check () {
      if (this.user.type === 'staff' && this.agreement.deposit_method === 2) {
        alert('支払方法が現金です、MGRに確認してください。')
        document.activeElement.blur()
      } else {
        return
      }
    }

    // getYubin (e) {
    //   let that = this
    //   console.log(e)
    //   const value = e.target.value
    //   if (value.length > 5) {
    //     jsonp('http://zipcloud.ibsnet.co.jp/api/search?zipcode=' + value, null, function (err, data) {
    //       if (err) {
    //         // error
    //         console.error(err.message)
    //       } else {
    //         // success
    //         console.log(data)
    //         that.family.pref = data.results[0].address1
    //         that.family.address1 = data.results[0].address2 + data.results[0].address3
    //       }
    //     })
    //   }
    // },
  }
}
</script>

<style lang='scss' scoped>
.req {
  /* background: #dffbef; */
  background: #41b883;
}
table {
  border-spacing: 0;
  width: 100%;
  border-top: solid 1px #ddd;
  tr {
    th {
      /* border-bottom: solid 1px #ddd; */
      /* background: #f4f4f4; */
      background: #37474f;
      /* color: #333; */
      color: #fbfbfb;
      padding: .5rem;
      font-weight: normal;
      font-size: .85rem;
    }
    td {
      border-bottom: solid 1px #ddd;
      border-right: solid 1px #ddd;
      input, textarea {
        outline: 0;
        border: none;
        width: 100%;
        padding: .5rem;
        font-size: .85rem;
        &:focus {
          background: #cdeeff;
        }
      }
      textarea {
        height: 150px;
        &:focus {
          background: #cdeeff;
        }
      }
    }
  }
}

.bank {
  position: absolute;
  top: 8px;
  right: 10px;
}
</style>
<style lang="scss">
.AgreementForm {
  .multiselect {
    min-height: 26px;
  }
  .multiselect__tags {
    border: 0;
    min-height: 26px;
    padding: 0px 40px 0 2px;
    font-size: .85rem;
  }
  .multiselect__input {
    margin-bottom: 0;
    height: 26px;
    font-size: .85rem;
  }
  .multiselect__select {
    height: 26px;
  }
  .multiselect__single {
    margin-top: 3px;
    margin-bottom: 3px;
  }
  .multiselect__placeholder {
    padding: .5rem 3px;
    margin: 0;
    color: #ccc;
  }
}
</style>



// WEBPACK FOOTER //
// AgreementForm.vue?64ad30b6